@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../constants/spacing.module.less';

.verify-buttons {
  padding: @space-16;

  > button {
    padding: @space-12;
    height: auto;
    min-width: 400px;
  }

  .edit-button {
    color: @scan-page--verify-footer-button--text-color;
  }
}
